import React from "react";

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const EditorFadeInIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg
      width="15"
      height="9"
      viewBox="0 0 15 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        id="Vector 429"
        d="M14.5 3.3999L11.5 0.399902M14.5 3.3999L11.5 6.3999M14.5 3.3999H12.721C10.9566 3.3999 9.24176 3.98317 7.84329 5.05891L5.65671 6.74089C4.25824 7.81664 2.54338 8.3999 0.779024 8.3999H0"
        stroke={fillColor || "white"}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { EditorFadeInIcon };
